var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRender)?_c('adjust-config',{attrs:{"params":_vm.params}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }